import React from 'react';

interface ToggleProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    label?: string;
    disabled?: boolean;
}

export const Toggle: React.FC<ToggleProps> = ({
    checked,
    onChange,
    label,
    disabled = false,
}) => {
    return (
        <div className="toggle-wrapper">
            <div
                className={`toggle ${checked ? 'active' : ''}`}
                onClick={() => !disabled && onChange(!checked)}
                style={{ opacity: disabled ? 0.5 : 1, cursor: disabled ? 'not-allowed' : 'pointer' }}
            >
                <div className="toggle-knob" />
            </div>
            {label && <span className="toggle-label">{label}</span>}
        </div>
    );
};
